import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const sliders = document.querySelectorAll('.block-slider__slider');

if (sliders.length > 0) {
    sliders.forEach(slider => {
      new Swiper(slider, {
        direction: 'horizontal',
        slidesPerView: 'auto',
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
      });
    });
}
